import { makeStyles } from '../../../../styles';
export default makeStyles((theme) => ({
    dialog: {
        padding: theme.spacing(2.5),
        height: '100%',
        '& .MuiDialog-paper': {
            maxWidth: '1226px',
            width: '100%',
            margin: '0 auto',
        },
    },
    restrictionBanner: {
        marginBottom: theme.spacing(2.5),
    },
    largeGrid: {
        display: 'grid',
        gridGap: theme.spacing(2),
        gridTemplateColumns: `2fr 1fr`,
    },
}));
//# sourceMappingURL=GroupedColumnSelector.styles.js.map